import '../../assets/index21.css';var W = Object.defineProperty, j = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var c = Object.getOwnPropertySymbols;
var x = Object.prototype.hasOwnProperty, S = Object.prototype.propertyIsEnumerable;
var O = (e, l, t) => l in e ? W(e, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[l] = t, w = (e, l) => {
  for (var t in l || (l = {}))
    x.call(l, t) && O(e, t, l[t]);
  if (c)
    for (var t of c(l))
      S.call(l, t) && O(e, t, l[t]);
  return e;
}, k = (e, l) => j(e, z(l));
var D = (e, l) => {
  var t = {};
  for (var i in e)
    x.call(e, i) && l.indexOf(i) < 0 && (t[i] = e[i]);
  if (e != null && c)
    for (var i of c(e))
      l.indexOf(i) < 0 && S.call(e, i) && (t[i] = e[i]);
  return t;
};
import { jsx as n, jsxs as h } from "react/jsx-runtime";
import { useMemo as P } from "react";
import { ErrorMessage as A } from "../../molecules/ErrorMessage/index.js";
import { ComboboxChevron as Y } from "../../icons/ComboboxChevron.js";
import { Checkbox as K } from "../Checkbox/index.js";
import { Label as U } from "../Label/index.js";
import { g as V, a as H, u as J, C as p } from "../../Combobox-B4a2Iksy.js";
import { u as Q } from "../../use-uncontrolled-BT_j5D2R.js";
import { P as I, a as M } from "../../PillsInput-Bgs2vIq9.js";
import { G as X } from "../../Group-BfqEg6H9.js";
import { I as Z } from "../../Input-BTQVVzfq.js";
import { F as $ } from "../../Flex-z_b6pdCM.js";
import { C as q } from "../../CloseButton-B2Fc4OX_.js";
const oo = "MultiSelect-module__pillsInput___Ysa7c", eo = "MultiSelect-module__pill___E-PVY", lo = "MultiSelect-module__options___1-W33", to = "MultiSelect-module__option___IT-Wc", d = {
  pillsInput: oo,
  pill: eo,
  options: lo,
  option: to
}, Co = (no) => {
  var g = no, {
    defaultValue: e,
    description: l,
    disabled: t,
    error: i,
    data: b,
    label: _,
    placeholder: y,
    onChange: B,
    value: E,
    required: f,
    className: N
  } = g, F = D(g, [
    "defaultValue",
    "description",
    "disabled",
    "error",
    "data",
    "label",
    "placeholder",
    "onChange",
    "value",
    "required",
    "className"
  ]);
  const u = P(() => V(b), [b]), v = P(() => H(u), [u]), r = J({
    onDropdownClose: () => r.resetSelectedOption(),
    onDropdownOpen: (o) => {
      o === "keyboard" ? r.selectActiveOption() : r.updateSelectedOptionIndex("active");
    }
  }), [s, m] = Q({
    value: E,
    defaultValue: e || [],
    onChange: B
  }), G = (o) => {
    const a = v[o];
    m(
      s.includes(o) ? s.filter((T) => T !== o) : [...s, o],
      a
    );
  }, C = (o) => m(s.filter((a) => a !== o)), L = s.map((o) => /* @__PURE__ */ n(I, { withRemoveButton: !0, onRemove: () => C(o), className: d.pill, children: v[o].label }, o)), R = u.map((o, a) => /* @__PURE__ */ n(
    p.Option,
    {
      active: s.includes(o.value),
      value: o.value,
      onMouseOver: () => r.selectOption(a),
      className: d.option,
      disabled: o.disabled,
      children: /* @__PURE__ */ n(X, { gap: "sm", children: /* @__PURE__ */ n(
        K,
        {
          checked: s.includes(o.value),
          label: o.label,
          disabled: o.disabled,
          readOnly: !0,
          required: f
        }
      ) })
    },
    o.value
  ));
  return /* @__PURE__ */ h(p, { store: r, onOptionSubmit: G, withinPortal: !1, disabled: t, children: [
    /* @__PURE__ */ n(p.DropdownTarget, { children: /* @__PURE__ */ h(
      M,
      k(w({
        disabled: t,
        onClick: () => r.toggleDropdown(),
        pointer: !0,
        "data-expanded": r.dropdownOpened || void 0,
        rightSection: /* @__PURE__ */ n(Y, { size: "xs", error: i }),
        rightSectionPointerEvents: "none",
        classNames: { input: d.pillsInput },
        label: /* @__PURE__ */ n(U, { label: _, withAsterisk: f }),
        description: l,
        descriptionProps: { c: "gray.8" },
        error: i && /* @__PURE__ */ n(A, { error: i }),
        inputWrapperOrder: ["label", "input", i ? "error" : "description"],
        className: N
      }, F), {
        children: [
          /* @__PURE__ */ h(I.Group, { role: "group", "aria-label": "Selected options", children: [
            s.length > 0 ? L : /* @__PURE__ */ n(Z.Placeholder, { children: y }),
            /* @__PURE__ */ n(p.EventsTarget, { children: /* @__PURE__ */ n(
              M.Field,
              {
                type: "hidden",
                onBlur: () => r.closeDropdown(),
                onKeyDown: (o) => {
                  o.key === "Backspace" && (o.preventDefault(), C(s[s.length - 1]));
                }
              }
            ) })
          ] }),
          s.length > 0 && /* @__PURE__ */ n($, { align: "center", children: /* @__PURE__ */ n(
            q,
            {
              size: "sm",
              "aria-label": "Clear selection",
              onClick: (o) => {
                o.stopPropagation(), m([]);
              }
            }
          ) })
        ]
      })
    ) }),
    /* @__PURE__ */ n(p.Dropdown, { children: /* @__PURE__ */ n(p.Options, { "aria-label": _, className: d.options, children: R }) })
  ] });
};
export {
  Co as MultiSelect
};
